import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { roleOptions } from '../../data/profileQuestions';

interface Props {
  selected: string[];
  onChange: (selected: string[]) => void;
}

const RoleSelector: React.FC<Props> = ({ selected, onChange }) => {
  const handleToggle = (role: string) => {
    if (selected.includes(role)) {
      onChange(selected.filter((r) => r !== role));
    } else {
      onChange([...selected, role]);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        競技における役割
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
        あなたがチームや競技の中で担っていた役割を選んでください（複数選択可）
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {roleOptions.map((role) => (
          <Chip
            key={role}
            label={role}
            onClick={() => handleToggle(role)}
            color={selected.includes(role) ? 'primary' : 'default'}
            variant={selected.includes(role) ? 'filled' : 'outlined'}
            sx={{ fontSize: '0.9rem', py: 2 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default RoleSelector;
